// dependencies
import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

// components
import TextInput from "@cloudspire/legacy-resources/src/components/TextInput2";
import Button from "@cloudspire/legacy-resources/src/components/Button2";

function DiscountCodeInput(props) {
  const { name, parameterList, loading, onChange } = props;

  const intl = useIntl();

  const [inputValue, setInputValue] = useState("");

  const discountCodes = parameterList?.[name] ?? [];

  function handlePressApply() {
    if (
      !discountCodes.some((discountCode) => discountCode === inputValue) &&
      inputValue.length > 0
    ) {
      onChange({
        target: {
          name,
          value: [...discountCodes, inputValue],
        },
      });
    }

    setInputValue("");
  }

  const handleChangeCode = useCallback((event) => {
    setInputValue(event.target.value.toUpperCase());
  }, []);

  return (
    <TextInput
      name={name}
      id="bookingDiscountCode"
      value={inputValue}
      disabled={loading}
      label={intl.formatMessage({
        defaultMessage: "Code promo",
      })}
      rightAddon={
        <div style={{ position: "relative", zIndex: 1 }}>
          <Button
            appearance="primary"
            disabled={loading}
            label={intl.formatMessage({
              defaultMessage: "Appliquer",
            })}
            onPress={handlePressApply}
          />
        </div>
      }
      onChange={handleChangeCode}
    />
  );
}

DiscountCodeInput.propTypes = {
  name: PropTypes.string,
  loading: PropTypes.bool,
  parameterList: PropTypes.object,
  onChange: PropTypes.func,
};

export default DiscountCodeInput;
